import React, { FunctionComponent } from 'react'
import { Path, Rect, Svg } from 'react-native-svg'

import { Tooltip } from '../../atoms/tooltip/Tooltip'
import { colors } from '../../styles'
import { tID } from '../../utils'

export const DialecticalBehavioralTherapyIcon: FunctionComponent<DialecticalBehavioralTherapyIconProps> = ({
  showTooltip = false,
  tooltipLabel = 'Dialectical Behavioral Therapy',
  width = 44,
  height = 44,
}) => {
  const icon = (
    <Svg width={width} height={height} viewBox={'0 0 44 44'} testID={tID('DialecticalBehavioralTherapyIcon')}>
      <Rect width={44} height={44} fill={colors.navy1} />
      <Path
        fill={colors.navy5}
        fillRule='evenodd'
        d='M12 10 L17 10 C29 10 34 14 34 22 C34 30 29 34 17 34 L12 34 Z M17 14 C26 14 30 17 30 22 C30 27 26 30 17 30 Z'
      />
    </Svg>
  )

  return showTooltip ? (
    <Tooltip content={tooltipLabel} placement='bottom' hoverEnabled={true}>
      {icon}
    </Tooltip>
  ) : (
    <>{icon}</>
  )
}

type DialecticalBehavioralTherapyIconProps = {
  showTooltip?: boolean
  tooltipLabel?: string
  width?: number
  height?: number
}
